var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V5.5L10 5.5V7.5H12V9.5H14L14 11.5H16V13.5H14V15.5H12V17.5H10L10 19.5H8L8 17.5H10V15.5L12 15.5V13.5H14V11.5H12V9.5H10V7.5L8 7.5Z",
    fill: "#1A5C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDotted);
export default __webpack_public_path__ + "static/media/arrow-right-dotted.3beb7d353dfbaa07467a3c87fa45f6d9.svg";
export { ForwardRef as ReactComponent };